// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 31) return "static/css/31.e919d21c0.chunk.css";
	// return url for filenames based on template
	return undefined;
};